 $(document).ready(function () {
 setTimeout(function () {
if ($('.gta-content__container').length > 0) {
  $('.header-visible').removeClass('header-padding-zer');
  //alert("yes");
} else {
   // alert("no");
  $('.header-visible').addClass('header-padding-zer');
}
         }, 1000);

         var checkInterval = setInterval(function () {
  if ($('.gta-content__container').length > 0) {
    $('.header-visible').removeClass('header-padding-zer');
   // alert("yes");
  } else {
    //alert("no");
    $('.header-visible').addClass('header-padding-zer');

    // Stop when class is added
    if ($('.header-visible').hasClass('header-padding-zer')) {
      clearInterval(checkInterval);
    }
  }
}, 1000); // Every 1 seconds

});